import { useQuery } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';

/**
 * GET /api/eraf/terminology/summary
 * queryKey: ['terminology', 'summary']
 */
export function useTerminologySummary() {
  return useQuery({
    queryKey: ['terminology', 'summary'],
    queryFn: () => terminologyApi.getSummary(),
    staleTime: 30_000,
  });
}
